import ResultsSearch from "cms/components/shared/ResultsSearch";

export default [
  {
    path: "/rechercher",
    component: ResultsSearch
  }
];
